import React from "react";
import { Modal, ModalBody,Button } from "reactstrap";



const AlertModal = ({message,isOpen,toggle,args})=>{
    return(
        <Modal centered className="alert-modal" isOpen={isOpen} toggle={toggle} {...args}>
        <ModalBody className="text-center">
         <p className="mb-4">{message}</p>
          <div>
          <Button color="light" className="border-0 me-3" onClick={toggle}>
            Cancel
          </Button>{' '}
          <Button color="secondry" size="sm" onClick={toggle}>
             Change Status
          </Button>
          </div>
        </ModalBody>
        
      </Modal>
    )
}

export default AlertModal;